import { getOrganizationFunctionsApi } from 'api/admin';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const getOrgFunctionsTreeApi = getOrganizationFunctionsApi;

export const getLevelUpDetailsApi = ({ employeeId }) => {
  const url = endpoints.growth.oneOnOne.index(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getCompetenciesForRoleApi = ({ employeeId, functionId, roleId }) => {
  const url = endpoints.growth.oneOnOne.getCompetenciesForRole(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      functionId,
      roleId,
    },
  });
};

export const getLevelUpTargetDatesAndProgressStatusesApi = ({ employeeId }) => {
  const url = endpoints.growth.oneOnOne.options(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const updateEmployeeTargetRoleApi = ({ employeeId, jobFunctionId, jobRoleId }) => {
  const url = endpoints.growth.oneOnOne.pickRole(employeeId);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      jobFunctionId,
      jobRoleId,
    },
  });
};

export const updateCompetencyTargetDateApi = ({
  employeeId,
  jobFunctionId,
  jobRoleId,
  competencyId,
  subCompetencyId,
  targetPeriodStart,
}) => {
  const url = endpoints.growth.oneOnOne.comptencyPeriod(employeeId);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      jobFunctionId,
      jobRoleId,
      competencyId,
      subCompetencyId,
      targetPeriodStart,
    },
  });
};

export const updateCompetencyProgressStatusApi = ({
  employeeId,
  jobFunctionId,
  jobRoleId,
  competencyId,
  subCompetencyId,
  progress,
  comment,
}) => {
  const url = endpoints.growth.oneOnOne.competencyStatus(employeeId);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      jobFunctionId,
      jobRoleId,
      competencyId,
      subCompetencyId,
      progress,
      comment,
    },
  });
};

export const getLevelUpCompetencyDetailsApi = ({ employeeId, levelUpId, competencyId, levelUpCompetencyId }) => {
  const url = endpoints.growth.oneOnOne.details(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      levelUpId,
      competencyId,
      levelUpCompetencyId,
    },
  });
};

export const getLevelUpCompetencyCommentsApi = ({ levelUpCompetencyId, offset, limit }) => {
  const url = endpoints.tasks.comments(levelUpCompetencyId);
  return sendRequest({
    url,
    method: 'GET',
    queryParams: {
      type: 'LEVELUP_COMPETENCY',
      offset,
      limit,
    },
    credentials: 'include',
  });
};

export const createLevelUpCompetencyCommentApi = ({
  commentBody,
  isKudos = false,
  employeeId,
  competencyId,
  levelUpId,
  subCompetencyId,
}) => {
  const url = endpoints.growth.oneOnOne.comment.create(employeeId);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      isKudos,
      competencyId,
      levelUpId,
      subCompetencyId,
    },
    body: commentBody,
  });
};

export const updateLevelUpCompetencyCommentApi = ({
  commentBody,
  isKudos = false,
  employeeId,
  commentId,
  competencyId,
  levelUpId,
  subCompetencyId,
}) => {
  const url = endpoints.growth.oneOnOne.comment.update(employeeId, commentId);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      isKudos,
      competencyId,
      levelUpId,
      subCompetencyId: subCompetencyId ?? null,
    },
    body: commentBody,
  });
};

export const addCompetencyToAgendaApi = ({ employeeId, body }) => {
  const url = endpoints.levelUp.addCompetencyToAgenda(employeeId);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};
